<template>
  <div ref="basicPortContent" class="basicPortContent">
    <Breadcrumb :matched="matched" />
    <loading v-show="isLoadings" />
    <div class="serachBack">
      <el-form
        ref="ruleForm"
        size="mini"
        label-position="right"
        :model="ruleForm"
        label-width="120px"
      >
        <div class="contentLeft">
          <el-row>
            <el-col style="width: 24%">
              <el-form-item label="账号">
                <el-input
                  v-model="ruleForm.uname"
                  clearable
                  style="width: 100%"
                  placeholder="请输入"
                />
              </el-form-item>
            </el-col>
            <el-col style="width: 24%">
              <el-form-item label="手机号">
                <el-input
                  v-model="ruleForm.phone"
                  clearable
                  style="width: 100%"
                  placeholder="请输入"
                />
              </el-form-item>
            </el-col>
            <el-col style="width: 24%">
              <el-form-item label="单号">
                <el-input
                  v-model="ruleForm.billNo"
                  clearable
                  style="width: 100%"
                  placeholder="请输入"
                />
              </el-form-item>
            </el-col>
            <el-col style="width: 24%">
              <el-form-item label="箱号">
                <el-input
                  v-model="ruleForm.containerNo"
                  clearable
                  style="width: 100%"
                  placeholder="请输入"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col style="width: 24%">
              <el-form-item label="港区代码">
                <el-input
                  v-model="ruleForm.port"
                  clearable
                  style="width: 100%"
                  placeholder="请输入"
                />
              </el-form-item>
            </el-col>
            <el-col style="width: 24%">
              <el-form-item label="船公司代码">
                <el-input
                  v-model="ruleForm.carrier"
                  clearable
                  style="width: 100%"
                  placeholder="请输入"
                />
              </el-form-item>
            </el-col>
            <el-col style="width: 24%">
              <el-form-item label="进出口标识">
                <el-select
                  v-model="ruleForm.ieid"
                  clearable
                  style="width: 100%"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in ieids"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col style="width: 24%">
              <el-form-item label="结果">
                <el-select
                  v-model="ruleForm.result"
                  clearable
                  style="width: 100%"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in resultList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col style="width: 24%">
              <el-form-item label="用户类型">
                <el-select
                  v-model="ruleForm.utype"
                  clearable
                  placeholder="请选择"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in typeList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col style="width: 24%">
              <el-form-item label="订阅时间">
                <el-date-picker
                  v-model="ruleForm.startTime"
                  type="date"
                  style="width: 100%"
                  value-format="yyyy-MM-dd"
                  placeholder="开始日期"
                />
              </el-form-item>
            </el-col>
            <el-col style="width: 24%">
              <el-form-item label="——">
                <el-date-picker
                  v-model="ruleForm.endTime"
                  style="width: 100%"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="结束日期"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div class="contenRight">
          <el-button size="small" class="serachBtn" @click="serchBtn">
            搜索
          </el-button>
        </div>
        <div style="clear: both"></div>
      </el-form>
    </div>
    <div class="tablePage">
      <div class="buttonTop">
        <el-button
          size="small"
          class="teshunormal"
          :loading="exporting"
          @click="handleExportClick"
        >
          导出
        </el-button>
        <!--                <el-button size="small" class="teshunormal" @click="handleClickSubscribe">重新订阅</el-button>-->
      </div>
      <el-table
        ref="table"
        :data="tableData"
        style="width: 100%"
        :header-cell-style="{
          background: '#3bafda',
          color: '#ffffff',
          fontSize: '12px',
        }"
        :row-class-name="tabRowClassName"
        tooltip-effect="dark"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          prop="utypeStr"
          label="用户类型"
          :show-overflow-tooltip="true"
          align="left"
          width="100"
          :sortable="sortableState"
          :filters="[]"
        />
        <el-table-column
          prop="uname"
          label="账号"
          :show-overflow-tooltip="true"
          align="left"
          min-width="100"
          :sortable="sortableState"
          :filters="[]"
        />
        <el-table-column
          prop="companyName"
          label="公司"
          :show-overflow-tooltip="true"
          align="left"
          min-width="120"
          :sortable="sortableState"
          :filters="[]"
        />

        <el-table-column
          prop="phone"
          label="手机号"
          :show-overflow-tooltip="true"
          align="left"
          min-width="120"
          :sortable="sortableState"
          :filters="[]"
        />
        <!--              <el-table-column  prop="pol" label="起运港"  :show-overflow-tooltip=true align="left" min-width="100" :sortable="sortableState" :filters="[]">-->

        <!--                </el-table-column>-->
        <!--                <el-table-column  prop="dtp" label="卸货港"  :show-overflow-tooltip=true align="left" min-width="100" :sortable="sortableState" :filters="[]">-->

        <!--                </el-table-column>-->
        <el-table-column
          prop="billNo"
          label="单号"
          :show-overflow-tooltip="true"
          align="left"
          min-width="160"
          :sortable="sortableState"
          :filters="[]"
        />
        <el-table-column
          prop="containerNo"
          label="箱号"
          :show-overflow-tooltip="true"
          align="left"
          min-width="160"
          :sortable="sortableState"
          :filters="[]"
        />
        <el-table-column
          prop="carrier"
          label="船公司代码"
          :show-overflow-tooltip="true"
          align="left"
          min-width="100"
          :sortable="sortableState"
          :filters="[]"
        />
        <el-table-column
          prop="port"
          label="港区代码"
          :show-overflow-tooltip="true"
          align="left"
          min-width="100"
          :sortable="sortableState"
          :filters="[]"
        />
        <el-table-column
          prop="ieidStr"
          label="进出口标识"
          :show-overflow-tooltip="true"
          align="left"
          min-width="100"
          :sortable="sortableState"
          :filters="[]"
        />
        <el-table-column
          prop="resultStr"
          label="结果"
          :show-overflow-tooltip="true"
          align="left"
          min-width="100"
          :sortable="sortableState"
          :filters="[]"
        />
        <el-table-column
          prop="createTime"
          label="第一次订阅时间"
          :show-overflow-tooltip="true"
          align="left"
          width="162"
          :sortable="sortableState"
          :filters="[]"
        />
        <el-table-column
          prop="updateTime"
          label="首次获取数据时间"
          :show-overflow-tooltip="true"
          align="left"
          width="162"
          :sortable="sortableState"
          :filters="[]"
        />
        <el-table-column
          prop="portUpdateTime"
          label="港区首次获取数据时间"
          :show-overflow-tooltip="true"
          align="left"
          width="162"
          :sortable="sortableState"
          :filters="[]"
        />
        <el-table-column
          prop="carrierUpdateTime"
          label="船公司首次获取数据时间"
          :show-overflow-tooltip="true"
          align="left"
          width="162"
          :sortable="sortableState"
          :filters="[]"
        />
        <!--                <el-table-column  prop="firstHasdataTime"  label="数据第一次返回时间" :show-overflow-tooltip=true align="left" width="172" :sortable="sortableState" :filters="[]">-->

        <!--                </el-table-column>-->
        <!--                <el-table-column  prop="isCharge"  label="是否收费" :show-overflow-tooltip=true align="left" width="100" :sortable="sortableState" :filters="[]">-->

        <!--                </el-table-column>-->
        <!--                <el-table-column  prop="firstVesselPlanTime"  label="第一次获取到船舶计划时间" :show-overflow-tooltip=true align="left" width="200" :sortable="sortableState" :filters="[]">-->

        <!--                </el-table-column>-->
        <!--                <el-table-column  prop="firstTerminalTime"  label="第一次获取到港区数据时间" :show-overflow-tooltip=true align="left" width="200" :sortable="sortableState" :filters="[]">-->

        <!--                </el-table-column>-->
        <!--                <el-table-column  prop="firstCarrierTime"  label="第一次获取到船东数据时间" :show-overflow-tooltip=true align="left" width="200" :sortable="sortableState" :filters="[]">-->

        <!--                </el-table-column>-->
        <!--                <el-table-column  prop="eta"  label="预计靠泊" :show-overflow-tooltip=true align="left" width="142" :sortable="sortableState" :filters="[]">-->

        <!--                </el-table-column>-->
        <!--                <el-table-column  prop="ata"  label="实际靠泊" :show-overflow-tooltip=true align="left" width="142" :sortable="sortableState" :filters="[]">-->

        <!--                </el-table-column>-->
        <!--                <el-table-column  prop="etd"  label="预计离港" :show-overflow-tooltip=true align="left" width="142" :sortable="sortableState" :filters="[]">-->

        <!--                </el-table-column>-->
        <!--                <el-table-column  prop="atd"  label="实际离港" :show-overflow-tooltip=true align="left" width="142" :sortable="sortableState" :filters="[]">-->

        <!--                </el-table-column>-->
        <!--                <el-table-column  prop="gitm"  label="进港(GITM)" :show-overflow-tooltip=true align="left" width="142" :sortable="sortableState" :filters="[]">-->

        <!--                </el-table-column>-->
        <!--                <el-table-column  prop="pass"  label="海放(PASS)" :show-overflow-tooltip=true align="left" width="142" :sortable="sortableState" :filters="[]">-->

        <!--                </el-table-column>-->
        <!--                <el-table-column  prop="tmps"  label="码放(TMPS)" :show-overflow-tooltip=true align="left" width="142" :sortable="sortableState" :filters="[]">-->

        <!--                </el-table-column>-->
        <!--                <el-table-column  prop="lobd"  label="装船(LOBD)" :show-overflow-tooltip=true align="left" width="142" :sortable="sortableState" :filters="[]">-->

        <!--                </el-table-column>-->
        <!--                <el-table-column  prop="stsp"  label="提空箱(STSP)" :show-overflow-tooltip=true align="left" width="142" :sortable="sortableState" :filters="[]">-->

        <!--                </el-table-column>-->
        <!--                <el-table-column  prop="dlpt"  label="离港(DLPT)" :show-overflow-tooltip=true align="left" width="142" :sortable="sortableState" :filters="[]">-->

        <!--                </el-table-column>-->
        <!--                <el-table-column  prop="bdar"  label="到港(BDAR)" :show-overflow-tooltip=true align="left" width="142" :sortable="sortableState" :filters="[]">-->

        <!--                </el-table-column>-->
        <!--                <el-table-column  prop="dsch"  label="卸船(DSCH)" :show-overflow-tooltip=true align="left" width="142" :sortable="sortableState" :filters="[]">-->

        <!--                </el-table-column>-->
        <!--                <el-table-column  prop="stcs"  label="提货(STCS)" :show-overflow-tooltip=true align="left" width="142" :sortable="sortableState" :filters="[]">-->

        <!--                </el-table-column>-->
        <!--                <el-table-column  prop="rcve"  label="还空(RCVE)" :show-overflow-tooltip=true align="left" width="142" :sortable="sortableState" :filters="[]">-->

        <!--                </el-table-column>-->
        <!--                <el-table-column  prop="remark"  label="备注" :show-overflow-tooltip=true align="left" width="280" :sortable="sortableState" :filters="[]">-->
        <!--                    <template slot-scope="scope">-->
        <!--                        <el-input-->
        <!--                         class="sel-el"-->
        <!--                        v-model="scope.row.remark"-->
        <!--                        maxlength="30"-->
        <!--                        placeholder="最多输入30字"-->
        <!--                        @change="changeRemark(scope.row)"-->
        <!--                        >-->
        <!--                        </el-input>-->
        <!--                    </template>-->
        <!--                </el-table-column>-->
        <!--                <el-table-column prop="operuser" label="操作人" align="left" :show-overflow-tooltip="true" min-width="80" :sortable="sortableState" :filters="[]">-->
        <!--                    <template slot-scope="scope">-->
        <!--                        {{scope.row.operuser ? scope.row.operuser.toUpperCase() : ''}}-->
        <!--                    </template>-->
        <!--                </el-table-column>-->
        <!--                <el-table-column prop="operTime" label="操作时间" align="left" :show-overflow-tooltip="true" :sortable="sortableState" :filters="[]" width="142">-->
        <!--                -->
        <!--                </el-table-column>-->
        <template slot="empty">
          <noData />
        </template>
      </el-table>
      <!--分页-->
      <ThePagination
        ref="refPagination"
        :page-number="pageNumber"
        :attribute="paginationAttribute"
        class="refPagination"
      />
    </div>
  </div>
</template>

<script>
import ThePagination from '@/components/ThePagination/ThePagination.vue'
import Breadcrumb from '@/components/Breadcrumb/Breadcrumb.vue'
import loading from '@/components/Loading/outLoading.vue'
import noData from '@/components/noData/index.vue'

export default {
  components: {
    ThePagination,
    Breadcrumb,
    loading,
    noData,
  },
  data() {
    return {
      exporting: false,
      isLoadings: false,
      sortableState: false, //排序
      ruleForm: {
        uname: '',
        utype: '',
        billNo: '',
        containerNo: '',
        port: '',
        carrier: '',
        ieid: '',
        result: '',
        phone: '',
        startTime: '',
        endTime: '',
      },
      tableData: [],
      multipleSelection: [],
      //查询结果集合 0：成功 1：暂无数据
      resultList: [
        {
          value: '',
          label: '全部',
        },
        {
          value: 1,
          label: '有数据',
        },
        {
          value: 2,
          label: '无数据',
        },
        {
          value: 0,
          label: '请求错误',
        },
      ],
      // 类型
      typeList: [
        {
          value: '',
          label: '全部',
        },
        {
          value: 1,
          label: 'API',
        },
        {
          value: 2,
          label: '平台',
        },
      ],
      ieids: [
        {
          value: '',
          label: '全部',
        },
        {
          value: 'I',
          label: '进口',
        },
        {
          value: 'E',
          label: '出口',
        },
      ],
      pageNo: 1,
      pageSize: 10,
      total: 0,
      // 引用 ThePagination组件
      refPagination: {},
      paginationAttribute: {
        handleChange: this.handleChange,
      },
      //分页默认状态
      pageNumber: -1,
      page: {
        // 当前页数
        pageNo: 1,
        // 每页默认显示条数
        pageSize: 10,
        // 总条数
        total: 0,
      },
      matched: '',
    }
  },
  mounted() {
    this.matched = this.$route.matched
//    this.searchList()
    this.$bus.on('clickMenu', content => {
      this.$refs.table.clearSort()
      this.searchList()
      
    })
  },
  destroyed() {
    this.$bus.off('clickMenu')
  },
  methods: {
    searchList(abnormal) {
      const params = {
        ...this.ruleForm,
        pageSize: this.page.pageSize,
        pageNum: this.page.pageNo,
      }

      if (params.startTime) {
        params.startTime += ' 00:00:00'
      }

      if (params.endTime) {
        params.endTime += ' 23:59:59'
      }

      this.isLoadings = true
      this.$axios
        .get(this.commonJs.localUrl + `/schedules/trace/newReport`, {
          params: params,
          headers: {
            Authorization: `Bearer ${this.getAuthorization()}`,
            AccessToken: this.getCookie('token').replace('Bearer', 'Jwt'),
          },
        })
        .then(res => {
          if (res.data.status === 1) {
            if (res.data.content) {
              if (res.data.content.length <= 0) {
                this.tableData = []
                if (this.$refs.refPagination) {
                  this.$refs.refPagination.page.total = res.data.total
                  this.$refs.refPagination.changeValue()
                }
              } else {
                if (res.data.status === 1) {
                  this.tableData = []
                  this.tableData = res.data.content
                  if (this.$refs.refPagination) {
                    this.$refs.refPagination.page.total = res.data.total
                    this.$refs.refPagination.changeValue()
                  }
                }
                if (this.$refs.refPagination) {
                  if (
                    Math.ceil(
                      this.$refs.refPagination.page.total / this.page.pageSize
                    ) < this.page.pageNo
                  ) {
                    this.$refs.refPagination.handleCurrentChange(1)
                  }
                }
              }
              if (abnormal) {
                this.$message.success('设置成功')
                let scroll = document.getElementById('elmain')
                scroll.style.overflowY = 'auto'
              }
            }
          } else if (res.data.status === 0) {
            this.$message({
              type: 'error',
              message: '数据加载失败 请重新加载页面',
            })
          }
        })
        .finally(() => (this.isLoadings = false))
    },
    //全选
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    //导出
    handleExportClick() {
      if (this.$refs.refPagination.page.total > 100000) {
        this.$message({
          type: 'error',
          message: '单次导出不可大于10万条',
        })
        return
      }

      const params = {
        ...this.ruleForm,
        total: this.$refs.refPagination.page.total,
      }

      if (params.startTime) {
        params.startTime += ' 00:00:00'
      }

      if (params.endTime) {
        params.endTime += ' 23:59:59'
      }

      this.exporting = true
      this.$axios({
        method: 'get',
        url: this.commonJs.localUrl + `/schedules/trace/exportNewReport`,
        params: params,
        responseType: 'blob',
        headers: {
          Authorization: `Bearer ${this.getAuthorization()}`,
          AccessToken: this.getCookie('token').replace('Bearer', 'Jwt'),
        },
      })
        .then(res => {
          let url = window.URL.createObjectURL(res.data)
          let link = document.createElement('a')
          link.style.display = 'none'
          link.href = url
          let contentDisposition = res.headers['content-disposition']
          if (contentDisposition) {
            let fileName = res.headers['content-disposition'].split('filename=')
            link.setAttribute('download', fileName[1])
            document.body.appendChild(link)
            link.click()
          } else {
            this.$message.error('暂无数据')
          }
        })
        .finally(() => (this.exporting = false))
    },
    //重新订阅
    // handleClickSubscribe() {
    //   this.subscribe = true;
    // },
    serchBtn() {
      this.$refs.refPagination.handleCurrentChange(1)
    },
    //给分页传的属性
    handleChange(params) {
      this.isLoadings = true
      this.page.pageSize = params.pageSize
      this.page.pageNo = params.pageNo
      this.searchList()
      this.pageNumber = -1
    },
    //表格的斑马线
    tabRowClassName({ row, rowIndex }) {
      let index = rowIndex + 1
      if (index % 2 !== 0) {
        return 'warning-row'
      }
    },

    //添加备注
    // changeRemark(item) {
    //   this.$axios
    //       .get(
    //           this.commonJs.localUrl +
    //           `/schedules/trace/updateRemark?id=${item.id}&remark=${item.remark}`,
    //           {
    //             headers: {
    //               Authorization: `Bearer ${this.getAuthorization()}`,
    //               AccessToken: this.getCookie("token").replace("Bearer", "Jwt")
    //             }
    //           }
    //       )
    //       .then(res => {
    //         if (res.data.status == 1) {
    //           //取当前时间
    //           var nowTime = this.commonJs.getDateTime(
    //               "YY-mm-dd HH:MM:SS",
    //               new Date()
    //           );
    //           item.operTime = nowTime;
    //           //取当前登录人
    //           item.operuser = this.getCookie("userName");
    //         } else {
    //           this.$message({
    //             type: "error",
    //             message: "数据加载失败 请重新加载页面"
    //           });
    //         }
    //       });
    // }
  },
}
</script>

<style lang="scss" scoped>
::v-deep .demo-table-expand {
  font-size: 0;
}

::v-deep .demo-table-expand label {
  width: 250px;
  color: #99a9bf;
}

::v-deep .el-row .el-col:nth-last-of-type(1) {
  margin-right: 0;
}

::v-deep .refPagination input {
  width: 100px !important;
}

::v-deep .el-table__expand-icon {
  visibility: hidden !important;
}

::v-deep .el-table__expanded-cell {
  text-align: center !important;
  color: #3bafda;
}

::v-deep .el-table th,
.el-table tr {
  height: 30px;
}

::v-deep .el-table th {
  height: 30px;
  padding: 0;
}

::v-deep .dateTime div:nth-child(1) {
  margin-left: 11px !important;
}

::v-deep .el-scrollbar__view .el-select-dropdown__list li:nth-of-type(1) {
  color: #409eff;
  font-weight: 700;
}

::v-deep .el-table .warning-row {
  background: rgba(241, 245, 247, 1) !important;
}

// ::v-deep .el-table .el-table__row:hover td{
//     background:rgba(241, 245, 247, 1);
// }
::v-deep .el-table .cell {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

::v-deep .el-table .caret-wrapper {
  height: 23px;
}

::v-deep .el-table .sort-caret.ascending {
  top: 0px;
}

::v-deep .el-table .sort-caret.descending {
  bottom: 1px;
}

.tablePage ::v-deep .el-icon-arrow-down::before {
  color: red;
  display: none;
  margin-left: -10px;
  height: 0;
}

::v-deep .el-table__column-filter-trigger {
  width: 0;
  height: 0;
}

.serachUL {
  list-style: none;
  margin: 0;
}

.serachUL li {
  display: inline-block;
}

.serachBtn {
  padding: 9px 35px;
  color: #fff;
  background-color: rgba(4, 153, 255, 1);
  margin-bottom: 10px;
  border: 1px solid #3bafda;
}

.subscribe {
  overflow: hidden;
}

.sel-el {
  overflow: hidden;
  width: 100%;
  height: 28px;
}

.sel-el ::v-deep .el-input__inner {
  height: 28px;
  line-height: 28px;
  padding-left: 10px;
  padding-right: 10px;
  font-size: 10px;
}

.sel-el ::v-deep .el-input__icon {
  line-height: 28px;
}

.sel-el ::v-deep .el-input__suffix {
  right: 0;
}

.exception {
  color: #ff0000;
  border: 1px solid #ff0000;
  font-size: 12px;
  border-radius: 3px;
  padding: 7px 15px;
  display: inline-block;
  white-space: nowrap;
  cursor: pointer;
  background: #fff;
  -webkit-appearance: none;
  text-align: center;
  box-sizing: border-box;
  outline: 0;
  margin: 0;
  transition: 0.1s;
  font-weight: 500;
  border-spacing: 2px;
  height: 28px;
  line-height: 14px;
}

.normal {
  color: #3bafda;
  border: 1px solid #3bafda;
  padding: 9px 15px;
  cursor: pointer;
  background: #fff;
  text-align: center;
  margin-right: 20px;
}

.exceptions {
  color: #ff0000;
}

.normals {
  color: #3bafda;
}

.contentLeft {
  float: left;
  width: 90%;
}

.contenRight {
  position: absolute;
  right: 20px;
  bottom: 5px;
}

.noClick {
  color: #b3c0d1;
}

.isClick {
  color: #409eff;
  cursor: pointer;
}

.basicPortContent {
  position: relative;
  overflow: hidden;
  padding: 20px 20px 0px 20px;

  .serachBack {
    background-color: #fff;
    padding: 20px 0px 0px 0px;
    margin-bottom: 10px;
    position: relative;
  }

  .tablePage {
    background-color: #fff;
    padding: 20px 20px 20px 20px;
  }

  .refPagination {
    width: 100%;
    background-color: #fff;
  }
}

label:nth-of-type(2) {
  width: 10px !important;
}

.buttonTop {
  margin-bottom: 20px;

  .clickColor {
    background-color: #fff;
    padding: 9px 15px;
    margin-right: 10px;
  }

  .teshunormal {
    color: #3bafda;
    border: 1px solid #3bafda;
    width: 80px;
    cursor: pointer;
    background: #fff;
    text-align: center;
    margin-right: 10px;
  }

  .normals {
    border: 1px solid #3bafda;
    color: #3bafda;
  }

  .abnormal {
    border: 1px solid #ff0000;
    color: #ff0000;
  }
}

::v-deep .el-table__empty-text {
  width: 100%;
}
</style>
